import AssetSubmissionVideos from "Components/Shared/AssetSubmissionVideos";

const PromotionalVideoSubmissions = () => {
  return <AssetSubmissionVideos uploadPurpose="featured" />;
};

export default PromotionalVideoSubmissions;
